import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Inventory from "./pages/Inventory";
import CarDetail from "./pages/CarDetail";
import Impressions from "./pages/Impressions";
import Partners from "./pages/Partners";
import HorseDetail from "./pages/HorseDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LegalPage from "./pages/LegalPage";
import { CookieConsent } from "./components/CookieConsent";
import { ScrollToTop } from "./components/ScrollToTop";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Seed data on first load
    const seed = async () => {
      try {
        await axios.post(`${API}/seed-data`);
      } catch (err) {
        // Silently fail if already seeded
      }
    };
    seed();
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen bg-[#0A0A0A]">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/inventory/:id" element={<CarDetail />} />
                <Route path="/impressions" element={<Impressions />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/partners/:id" element={<HorseDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/legal/:slug" element={<LegalPage />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppButton />
            <CookieConsent />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
